import type { IconToken } from '@core/user-interface-legacy';

import type { AskTicketPriority } from '../../../tickets/types/lib/ask-hr-tickets';

export const priorityColorMap: Record<AskTicketPriority, IconToken> = {
  low: 'colorIconDisabled',
  normal: 'colorIconInfoDefault',
  high: 'colorIconWarningDefault',
  urgent: 'colorIconCriticalStrongDefault',
};
